export default __webpack_public_path__ + "ee5e491b43680c160d4e24a05e70c11d.png";